/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginUser, loginUserWithTwoFactorAuthentication } from '../../actions';
import {
	InputOTP,
	InputOTPGroup,
	InputOTPSeparator,
	InputOTPSlot,
} from '@/components/ui/input-otp';
import { REGEXP_ONLY_DIGITS_AND_CHARS } from 'input-otp';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

// Phones: six 44px slots (narrower on a 320px screen so they still fit).
const PHONE_SLOT_CLASS =
	'max-md:h-12 max-md:w-[min(2.75rem,calc((100vw-4.5rem)/6))] max-md:text-xl';

const TwoFactorAuth = ({ _business, handleSubmitWithLoginDetails }) => {
	const dispatch = useDispatch();

	const [code, setCode] = useState('');
	const [error, setError] = useState('');
	const [isResendCodeButtonDisabled, setIsResendCodeButtonDisabled] =
		useState(false);
	const [formLoaded, setIsFormLoaded] = useState(false);
	const handleCodeChange = (value) => {
		const inputCode = value;

		// Ensure the input contains only numeric characters and limits it to 6 digits
		// const sanitizedCode = inputCode.replace(/\D/g, '').slice(0, 6);

		setCode(inputCode);
		setError(''); // Clear any previous error when the user types
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		if (code.length !== 6) {
			setError('Please enter a 6-digit code.');
			return;
		}

		await dispatch(
			loginUserWithTwoFactorAuthentication({
				_business,
				twoFactorAuthCode: code,
			})
		);
	};

	const disableResendCodeButton = () => {
		setIsResendCodeButtonDisabled(true);

		setTimeout(() => {
			setIsResendCodeButtonDisabled(false);
		}, 30000);
	};

	const resendCode = async (event) => {
		event.preventDefault();
		disableResendCodeButton();
		handleSubmitWithLoginDetails();
	};

	useEffect(() => {
		setIsFormLoaded(true);
	}, []);

	return (
		<form onSubmit={handleSubmit} className="grid gap-4 w-full">
			<h1 className="md:hidden pt-4 text-center text-[28px] font-bold leading-tight tracking-tight">
				Two-step verification
			</h1>
			<h2 className="font-semibold text-sm max-md:-mt-2 max-md:text-center max-md:text-[15px] max-md:font-normal max-md:text-muted-foreground">
				Enter your six-digit two factor authentication code
			</h2>

			<div className="flex justify-center w-full max-md:py-2">
				<InputOTP
					value={code}
					onChange={(value) => handleCodeChange(value)}
					maxLength={6}
					pattern={REGEXP_ONLY_DIGITS_AND_CHARS}
					aria-label="Authentication code"
					enterKeyHint="done"
				>
					<InputOTPGroup>
						<InputOTPSlot index={0} className={PHONE_SLOT_CLASS} />
						<InputOTPSlot index={1} className={PHONE_SLOT_CLASS} />
						<InputOTPSlot index={2} className={PHONE_SLOT_CLASS} />
					</InputOTPGroup>
					<InputOTPSeparator />
					<InputOTPGroup>
						<InputOTPSlot index={3} className={PHONE_SLOT_CLASS} />
						<InputOTPSlot index={4} className={PHONE_SLOT_CLASS} />
						<InputOTPSlot index={5} className={PHONE_SLOT_CLASS} />
					</InputOTPGroup>
				</InputOTP>
			</div>

			{/** resubmit the submit form */}

			<Button
				type="submit"
				className="max-md:h-[52px] max-md:rounded-xl max-md:text-[17px] max-md:font-semibold max-md:active:opacity-80"
			>
				Submit
			</Button>
			<div className="flex justify-end w-full max-md:justify-center">
				<Button
					variant="link"
					className="text-foreground max-md:h-11 max-md:text-[15px]"
					onClick={resendCode}
					disabled={isResendCodeButtonDisabled}
				>
					Resend Code
				</Button>
			</div>

			<div
				className={cn(
					error ? 'opacity-100' : 'opacity-0',
					'flex justify-center transition-opacity ease-in-out duration-300 min-h-5'
				)}
			>
				<h3 className="text-destructive text-sm text-center">
					{error}
				</h3>
			</div>
		</form>
	);
};

export default TwoFactorAuth;
